import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import {
  DriverModel,
  SharedVehicleGroupDriverViewModel
} from './../../driver/models/driver.model';
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  OnChanges
} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL,
  UserRoles,
  DataListModel
} from '../../shared/config';
import { InvoiceService } from '../models/invoice.service';

@Component({
  selector: 'wego-invoice-driver-popup',
  template: require('../views/invoice-driver-popup.component.html'),
  providers: [InvoiceService]
})
export class InvoiceDriverPopupComponent implements OnInit, OnChanges {
  DataListModel: DataListModel;
  driverList: SharedVehicleGroupDriverViewModel[];
  message: string;
  apiErrorMsg: string;
  isLoading: boolean;
  instanceHashId: string;
  companyHashId: string;

  @Output('OnSuccessSelect') onSuccessSelect = new EventEmitter();
  @ViewChild('driverModal') public driverModal: any;

  constructor(
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService,
    private invoiceService: InvoiceService
  ) {}

  ngOnInit() {
    this.DataListModel = new DataListModel();
    this.DataListModel.searchField = ['driverName', 'firstName', 'lastName'];
  }

  ngOnChanges(change: any) {
    console.log(change);
  }

  public show(instanceHashId: string, companyHashId: string): void {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.sortType = '';
    this.DataListModel.sortReverse = null;
    this.DataListModel.searchTerm = '';
    this.DataListModel.infoMessage = '';
    this.instanceHashId = instanceHashId;
    this.companyHashId = companyHashId;
    this.GetDriverList();
    this.driverModal.show();
  }

  public hide(): void {
    this.driverModal.hide();
  }

  private GetDriverList() {
    this.isLoading = true;
    this.invoiceService
      .GetDriverList(
        this.instanceHashId,
        this.DataListModel,
        this.companyHashId
      )
      .subscribe(
        res => {
          this.driverList = res.data;
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.isLoading = false;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  private select(driver: SharedVehicleGroupDriverViewModel): void {
    this.isLoading = true;
    this.onSuccessSelect.emit({
      DriverHashID: driver.driverHashId,
      SharedVehicleGroupDriverHashId: driver.sharedVehicleDriverHashId,
      DriverName: driver.driverName,
      DriverFullName:
        !driver.firstName && !driver.lastName
          ? driver.driverName
          : (
              (driver.firstName ? driver.firstName : ' ') +
              ' ' +
              (driver.lastName ? driver.lastName : ' ')
            ).trim()
    });
    this.isLoading = false;
    this.hide();
  }

  private OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetDriverList();
  }

  private OnSearch(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 1;
    this.GetDriverList();
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetDriverList();
  }

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetDriverList();
  }
  private OnSuccessSelect() {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/invoice/components/invoice-driver-popup.component.ts